import { render, staticRenderFns } from "./Picklrs.vue?vue&type=template&id=2d4798ae&scoped=true&"
import script from "./Picklrs.vue?vue&type=script&lang=js&"
export * from "./Picklrs.vue?vue&type=script&lang=js&"
import style0 from "./Picklrs.vue?vue&type=style&index=0&id=2d4798ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4798ae",
  null
  
)

export default component.exports